import { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";

const LocationCheck = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!location.state?.code) {
            navigate("/invalid");
        }
    }, []);

    return children;
};

LocationCheck.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};

export default LocationCheck;
